import { mapState } from 'vuex'

export default {

  computed: mapState({
    efilingUser (state) {
      if (!state.user) return null
      if (!state.user.efmUsers) return null
      const user = state.user.efmUsers[state.locale.current]
      return user
    },

    loggedIntoEfiling (state) {
      if (!this.efilingUser) return false
      return !!this.efilingUser.id
    },

    isEfilingFirmAdmin (state) {
      if (!this.efilingUser) return false
      return !!this.efilingUser.admin
    }
  })
}
